/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Tier_Student_LabelInputs */

const en_agb_tier_student_label = /** @type {(inputs: Agb_Tier_Student_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student (EUR 14.99/month, EUR 8.99/month billed annually): `)
};

const de_agb_tier_student_label = /** @type {(inputs: Agb_Tier_Student_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student (EUR 14,99/Monat, EUR 8,99/Monat bei jährlicher Abrechnung): `)
};

const fr_agb_tier_student_label = /** @type {(inputs: Agb_Tier_Student_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étudiant (EUR 14,99/mois, EUR 8,99/mois facturé annuellement) : `)
};

const es_agb_tier_student_label = /** @type {(inputs: Agb_Tier_Student_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estudiante (EUR 14,99/mes, EUR 8,99/mes facturado anualmente): `)
};

const it_agb_tier_student_label = /** @type {(inputs: Agb_Tier_Student_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studente (EUR 14,99/mese, EUR 8,99/mese fatturato annualmente): `)
};

const nl_agb_tier_student_label = /** @type {(inputs: Agb_Tier_Student_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student (EUR 14,99/maand, EUR 8,99/maand bij jaarlijkse facturering): `)
};

const pl_agb_tier_student_label = /** @type {(inputs: Agb_Tier_Student_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student (EUR 14,99/mies., EUR 8,99/mies. przy rozliczeniu rocznym): `)
};

const fi_agb_tier_student_label = /** @type {(inputs: Agb_Tier_Student_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opiskelija (EUR 14,99/kk, EUR 8,99/kk vuosilaskutuksella): `)
};

const da_agb_tier_student_label = /** @type {(inputs: Agb_Tier_Student_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studerende (EUR 14,99/måned, EUR 8,99/måned ved årlig fakturering): `)
};

const sv_agb_tier_student_label = /** @type {(inputs: Agb_Tier_Student_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Student (EUR 14,99/månad, EUR 8,99/månad vid årsfakturering): `)
};

/**
* | output |
* | --- |
* | "Student (EUR 14.99/month, EUR 8.99/month billed annually):" |
*
* @param {Agb_Tier_Student_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_tier_student_label = /** @type {((inputs?: Agb_Tier_Student_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Tier_Student_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_tier_student_label(inputs)
	if (locale === "fr") return fr_agb_tier_student_label(inputs)
	if (locale === "es") return es_agb_tier_student_label(inputs)
	if (locale === "it") return it_agb_tier_student_label(inputs)
	if (locale === "nl") return nl_agb_tier_student_label(inputs)
	if (locale === "pl") return pl_agb_tier_student_label(inputs)
	if (locale === "fi") return fi_agb_tier_student_label(inputs)
	if (locale === "da") return da_agb_tier_student_label(inputs)
	if (locale === "sv") return sv_agb_tier_student_label(inputs)
	return en_agb_tier_student_label(inputs)
});